<style lang="scss" src='./Dashboard.scss' scoped ></style>
<template src="./Dashboard.html"></template>

<script>
import WeatherWidget from "@/components/weather/WeatherWidget.vue";
import AlertList from "@/views/dashboard/alertList/AlertList.vue";
import TaskList from "@/views/dashboard/taskList/TaskList.vue";
import i18n from "./../../i18n";

import { mapState, mapActions, mapMutations } from "vuex";

const orderAlertOptions = [
  { value: "last_seen", i18n: "general.date" },
  { value: "alert_type_id", i18n: "dashboard.alertType" },
];
const orderTasksOptions = [
  { value: "time_updated", i18n: "general.date" },
  { value: "status", i18n: "general.status" },
];

export default {
  name: "Dashboard",
  components: {
    WeatherWidget,
    AlertList,
    TaskList,
  },
  data() {
    return {
      refreshDataInterval: null,
      can_create_tasks: false,
      orderAlertOptions: orderAlertOptions,
      alertsOrderBy: orderAlertOptions[0].value,
      orderTasksOptions: orderTasksOptions,
      tasksOrderBy: orderTasksOptions[0].value,
    };
  },
  computed: {
    ...mapState(["course"]),
    ...mapState("Dashboard", {
      localWeather: (state) => state.localWeather,
      microWeather: (state) => state.microWeather,
      precipitationTotals: (state) => state.precipitationTotals,
      loading: (state) => state.loading,
      alerts: (state) => state.alerts,
      tasks: (state) => state.tasks,
      dailyTemps: (state) => state.dailyTemps,
    }),
  },

  methods: {
    startIntervalToRefreshData() {
      this.refreshDataInterval = window.setInterval(() => {
        this.loadAlerts();
        this.loadTasks();
      }, process.env.VUE_APP_REFRESH_DATA_TIME_MS);
    },

    selectAlert(alert) {
      if (alert && alert.sensor) {
        // Temporal validation
        this.setSelectedAlert(alert);
        this.$router.push(`/alert/${alert.alert_id}/details`);
      }
    },

    validateUserPermissions() {
      let menuPolicy = this.$store.state.menuPolicy.find(
        (policy) => policy.vue_component == "TaskBoard"
      );

      if(menuPolicy && menuPolicy.policy){
        this.can_create_tasks = menuPolicy.policy.can_create;
      }
    },

    ...mapActions("Dashboard", [
      "loadWeather",
      "loadAlerts",
      "loadTasks",
      "loadPrecipitationTotals",
      "loadDailyTemps",
    ]),
    ...mapMutations("Dashboard", ["setSelectedAlert", "setCourseId"]),
  },

  beforeCreate() {},

  created() {},

  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Dashboard");
      this.$analytics.logEvent("web_dashboard");
    }

    this.validateUserPermissions();
    this.setCourseId(this.course.course_id);
    this.loadWeather();
    this.loadPrecipitationTotals();
    this.loadAlerts();
    this.loadTasks();
    this.loadDailyTemps();
    this.startIntervalToRefreshData();
  },

  beforeDestroy() {
    window.clearInterval(this.refreshDataInterval);
  },
};
</script>
